import { useParams, Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { loadArticle, getRelatedArticles, getAllArticles } from '../utils/articleLoader';
import SEO from '../components/SEO';

function Article() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const relatedArticles = getRelatedArticles(slug);

  useEffect(() => {
    async function fetchArticle() {
      setLoading(true);
      const data = await loadArticle(slug);
      if (data) {
        setArticle(data);
      }
      setLoading(false);
    }
    fetchArticle();
  }, [slug]);

  if (loading) {
    return <div className="text-center py-16"><p className="text-gray-600">Loading...</p></div>;
  }

  if (!article) {
    return (
      <div className="text-center py-16">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Article not found</h1>
        <Link to="/" className="text-gray-600 hover:text-gray-800 underline">Back to Home</Link>
      </div>
    );
  }

  return (
    <div>
      <SEO 
        title={`${article.title} | Mood Food Recommender`} 
        description={article.description} 
      />
      <article className="bg-white rounded-xl shadow-sm border p-6 mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">{article.title}</h1>
        <p className="text-gray-600 mb-6">{article.description}</p>
        <div className="prose prose-gray max-w-none">
          <ReactMarkdown>{article.content}</ReactMarkdown>
        </div>
      </article>

      <div className="mb-8">
        <Link to="/" className="inline-block bg-black text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition">
          ← Back to Mood Food Recommender
        </Link>
      </div>

      {relatedArticles.length > 0 && (
        <section className="bg-white rounded-xl shadow-sm border p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Related Articles</h2>
          <div className="space-y-3">
            {relatedArticles.map((related) => (
              <Link key={related.slug} to={`/articles/${related.slug}`} className="block p-4 rounded-lg border hover:bg-gray-50 transition">
                <h3 className="font-medium text-gray-900 mb-1">{related.title}</h3>
                <p className="text-sm text-gray-600">{related.description}</p>
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}

export default Article;
